import React from "react";
// mui 5
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Typography from "@mui/material/Typography";
// custom styled components
import { StyledQuantityControl } from "./styledComponents";
// custom context
import { useCart } from "../../context/CartContext";

function QuantityControl({ pokemon }) {
  const { onIncrementItemQuantity, onDecrementItemQuantity } = useCart();
  return (
    <StyledQuantityControl>
    {/* Decrement */}
      <IconButton
        aria-label="decrement quantity"
        test-id="decrement quantity"
        onClick={() => onDecrementItemQuantity(pokemon)}
      >
        <RemoveIcon sx={{ color: "#eee" }} />
      </IconButton>
      {/* Text */}
      <Typography sx={{ color: "#ccc" }}>{pokemon.quantity}</Typography>
      {/* Decrement */}
      <IconButton
        aria-label="increment quantity"
        test-id="increment quantity"
        onClick={() => onIncrementItemQuantity(pokemon)}
      >
        <AddIcon sx={{ color: "#eee" }} />
      </IconButton>
    </StyledQuantityControl>
  );
}

export default QuantityControl;
